module.exports = __webpack_public_path__ + "static/media/22.4fb62634.svg";